/* ============================================================
   FEMFORIA Shopify theme — app.js
   ============================================================ */
(function () {
  "use strict";

  /* Preloader — plays once per session, then never again */
  var pre = document.getElementById("preloader");
  if (pre) {
    var inEditor = window.Shopify && window.Shopify.designMode;
    var seen = document.documentElement.classList.contains("intro-seen");
    var hide = function () { pre.classList.add("is-done"); };
    if (inEditor || seen) {
      hide(); // already shown this session (or in the editor) — skip it
    } else {
      try { sessionStorage.setItem("ff_intro", "1"); } catch (e) {}
      window.addEventListener("load", function () { setTimeout(hide, 2300); });
      // safety: never let it get stuck
      setTimeout(hide, 4500);
    }
  }

  /* Sticky nav */
  var nav = document.getElementById("nav");
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle("is-stuck", window.scrollY > 40);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* Mobile menu */
  var burger = document.getElementById("burger");
  var links = document.getElementById("navLinks");
  if (burger && links) {
    burger.addEventListener("click", function () {
      burger.classList.toggle("is-open");
      links.classList.toggle("is-open");
    });
    links.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        burger.classList.remove("is-open");
        links.classList.remove("is-open");
      });
    });
  }

  /* Reveal on scroll */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
    });
  }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });
  document.querySelectorAll(".reveal").forEach(function (el, i) {
    el.style.transitionDelay = (i % 4) * 0.08 + "s";
    io.observe(el);
  });
  // Failsafe: anything still hidden after load gets revealed, so a missed
  // IntersectionObserver callback can never leave a section blank on mobile.
  window.addEventListener("load", function () {
    setTimeout(function () {
      document.querySelectorAll(".reveal:not(.is-in)").forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 1.2) el.classList.add("is-in");
      });
    }, 600);
  });

  /* Count-up stats */
  var countIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, target = parseInt(el.dataset.count, 10);
      if (isNaN(target)) { countIO.unobserve(el); return; }
      var isYear = target > 1000, cur = isYear ? target - 60 : 0;
      var step = Math.max(1, Math.ceil(target / 48));
      (function tick() {
        cur += step;
        if (cur >= target) cur = target; else requestAnimationFrame(tick);
        el.textContent = cur;
      })();
      countIO.unobserve(el);
    });
  }, { threshold: 0.6 });
  // Scope to the stat numbers only — NOT every [data-count]. The cart drawer
  // carries data-count for its item counter, and selecting it here would
  // overwrite the whole drawer's contents with the number.
  document.querySelectorAll(".stat [data-count]").forEach(function (el) { countIO.observe(el); });

  /* ============================================================
     Scroll engine — one rAF loop drives everything:
       • #scrollProgress reading bar
       • [data-scene]  → --p   (0 entering bottom → 1 leaving top)
       • [data-pin]    → --pin (0 → 1 across an over-scrolled section)
       • [data-parallax] gentle clamped drift (DESKTOP ONLY)
     Native scroll only — no smooth-scroll library (removed by request).
     Heavy transforms are gated off touch / reduced-motion devices, which
     is what was blanking the lookbook images on phones.
     ============================================================ */
  (function () {
    var reduce = window.matchMedia("(prefers-reduced-motion:reduce)").matches;
    var isDesktop =
      window.matchMedia("(min-width:1001px)").matches &&
      window.matchMedia("(hover:hover)").matches;

    var bar = document.getElementById("scrollProgress");
    var scenes = Array.prototype.slice.call(document.querySelectorAll("[data-scene]"));
    var pins = Array.prototype.slice.call(document.querySelectorAll("[data-pin]"));
    var parEls = (isDesktop && !reduce)
      ? Array.prototype.slice.call(document.querySelectorAll("[data-parallax]"))
      : [];

    var vh = window.innerHeight;
    var ticking = false;
    function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

    function frame() {
      ticking = false;
      var st = window.scrollY || window.pageYOffset || 0;

      if (bar) {
        var max = document.documentElement.scrollHeight - vh;
        bar.style.transform = "scaleX(" + (max > 0 ? (st / max).toFixed(4) : 0) + ")";
      }

      var i, r, p;
      for (i = 0; i < scenes.length; i++) {
        r = scenes[i].getBoundingClientRect();
        // "leave" → 0 while fully in view, 1 as it scrolls out the top (hero).
        // default → 0 entering from the bottom, 1 leaving the top.
        if (scenes[i].getAttribute("data-scene") === "leave") {
          p = clamp01(-r.top / (r.height || 1));
        } else {
          p = clamp01((vh - r.top) / (vh + r.height));
        }
        scenes[i].style.setProperty("--p", p.toFixed(4));
      }

      for (i = 0; i < pins.length; i++) {
        r = pins[i].getBoundingClientRect();
        var travel = r.height - vh;
        pins[i].style.setProperty("--pin", (travel > 0 ? clamp01(-r.top / travel) : 0).toFixed(4));
        pins[i].classList.toggle("is-pinned", r.top <= 1 && r.bottom >= vh - 1);
      }

      for (i = 0; i < parEls.length; i++) {
        r = parEls[i].getBoundingClientRect();
        var off = (r.top + r.height / 2 - vh / 2) * parseFloat(parEls[i].dataset.parallax);
        if (off > 70) off = 70; else if (off < -70) off = -70; // never drift far enough to leave gaps
        parEls[i].style.transform = "translate3d(0," + off.toFixed(1) + "px,0)";
      }
    }

    function onScroll() { if (!ticking) { requestAnimationFrame(frame); ticking = true; } }

    if (bar || scenes.length || pins.length || parEls.length) {
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", function () { vh = window.innerHeight; frame(); }, { passive: true });
      window.addEventListener("load", frame);
      frame();
    }
  })();

  /* Custom cursor */
  var cursor = document.getElementById("cursor"), dot = document.getElementById("cursorDot");
  if (cursor && window.matchMedia("(hover:hover)").matches) {
    var mx = 0, my = 0, cx = 0, cy = 0;
    document.addEventListener("mousemove", function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = "translate(" + mx + "px," + my + "px) translate(-50%,-50%)";
    });
    (function loop() {
      cx += (mx - cx) * 0.18; cy += (my - cy) * 0.18;
      cursor.style.transform = "translate(" + cx + "px," + cy + "px) translate(-50%,-50%)";
      requestAnimationFrame(loop);
    })();
    document.addEventListener("mouseover", function (e) {
      var el = e.target.closest("[data-cursor]");
      cursor.classList.remove("is-view", "is-hover");
      if (el) cursor.classList.add(el.getAttribute("data-cursor") === "view" ? "is-view" : "is-hover");
    });
  }

  /* Product variant selection: keep hidden <select name="id"> in sync */
  var form = document.getElementById("productForm");
  if (form) {
    var variantSelect = document.getElementById("variantSelect");
    var radios = form.querySelectorAll('input[type="radio"][data-option-index]');
    function currentOptions() {
      var opts = [];
      form.querySelectorAll('.pdp__option').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }
    function syncVariant() {
      if (!variantSelect) return;
      var chosen = currentOptions().join(" / ");
      Array.prototype.forEach.call(variantSelect.options, function (o) {
        if (o.text.split(" — ")[0] === chosen) variantSelect.value = o.value;
      });
    }
    radios.forEach(function (r) { r.addEventListener("change", syncVariant); });
    syncVariant();
  }

  /* ============================================================
     Announcement-bar height -> CSS var (nav sits below it at top)
     ============================================================ */
  function setAnbarH() {
    var bar = document.querySelector(".anbar");
    document.documentElement.style.setProperty("--anbar-h", (bar ? bar.offsetHeight : 0) + "px");
  }
  setAnbarH();
  window.addEventListener("resize", setAnbarH);

  /* Native scrolling — smooth-scroll library removed by request */
  var prefersReduce = window.matchMedia("(prefers-reduced-motion:reduce)").matches;
  var lenis = null;

  /* ============================================================
     Magnetic buttons
     ============================================================ */
  if (window.matchMedia("(hover:hover)").matches && !prefersReduce) {
    document.querySelectorAll(".btn, .nav__cta").forEach(function (el) {
      el.addEventListener("mousemove", function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.25;
        var y = (e.clientY - r.top - r.height / 2) * 0.4;
        el.style.transform = "translate(" + x.toFixed(1) + "px," + y.toFixed(1) + "px)";
      });
      el.addEventListener("mouseleave", function () { el.style.transform = ""; });
    });
  }

  /* ============================================================
     Hero image trail (product photos follow the cursor)
     ============================================================ */
  (function () {
    var trail = document.getElementById("heroTrail");
    if (!trail || !window.matchMedia("(hover:hover)").matches || prefersReduce) return;
    var imgs = (trail.dataset.images || "").split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    if (!imgs.length) return;
    var hero = trail.closest(".hero") || trail.parentElement;
    var lastX = 0, lastY = 0, idx = 0, primed = false;
    hero.addEventListener("mousemove", function (e) {
      var rect = trail.getBoundingClientRect();
      var x = e.clientX - rect.left, y = e.clientY - rect.top;
      if (!primed) { lastX = x; lastY = y; primed = true; return; }
      if (Math.hypot(x - lastX, y - lastY) < 95) return;
      lastX = x; lastY = y;
      var im = document.createElement("img");
      im.src = imgs[idx % imgs.length]; idx++;
      im.alt = "";
      im.style.left = x + "px";
      im.style.top = y + "px";
      im.style.setProperty("--r", (Math.random() * 16 - 8).toFixed(1) + "deg");
      trail.appendChild(im);
      void im.offsetWidth;
      im.classList.add("on");
      setTimeout(function () { im.remove(); }, 950);
    });
  })();

  /* ============================================================
     Letter-by-letter heading reveal
     ============================================================ */
  if (!prefersReduce) {
    document.querySelectorAll(".section-head__title, .cta__title").forEach(function (el) {
      if (el.dataset.split) return;
      el.dataset.split = "1";
      var text = el.textContent.trim();
      el.textContent = "";
      el.classList.add("split");
      var words = text.split(" ");
      words.forEach(function (word, wi) {
        var w = document.createElement("span");
        w.className = "word";
        word.split("").forEach(function (ch) {
          var s = document.createElement("span");
          s.className = "char";
          s.textContent = ch;
          w.appendChild(s);
        });
        el.appendChild(w);
        if (wi < words.length - 1) el.appendChild(document.createTextNode(" "));
      });
      el.querySelectorAll(".char").forEach(function (c, i) {
        c.style.transitionDelay = (i * 0.02).toFixed(2) + "s";
      });
    });
    var splitIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); splitIO.unobserve(e.target); }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll(".split").forEach(function (el) { splitIO.observe(el); });
  }

  /* ============================================================
     Drop countdown (announcement bar)
     ============================================================ */
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  document.querySelectorAll(".anbar__countdown").forEach(function (el) {
    var dl = el.getAttribute("data-deadline");
    if (!dl) return;
    var target = new Date(dl.replace(" ", "T")).getTime();
    if (isNaN(target)) return;
    var d = el.querySelector("[data-d]"), h = el.querySelector("[data-h]"),
        m = el.querySelector("[data-m]"), s = el.querySelector("[data-s]");
    var iv = setInterval(tick, 1000);
    tick();
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { clearInterval(iv); el.innerHTML = "<em>Live now ✦</em>"; setAnbarH(); return; }
      if (d) d.textContent = pad(Math.floor(diff / 86400000));
      if (h) h.textContent = pad(Math.floor(diff / 3600000) % 24);
      if (m) m.textContent = pad(Math.floor(diff / 60000) % 60);
      if (s) s.textContent = pad(Math.floor(diff / 1000) % 60);
    }
  });

  /* ============================================================
     Cart drawer + AJAX add-to-cart
     ============================================================ */
  var R = window.routes || { cart_add: "/cart/add.js", cart_change: "/cart/change.js", cart_url: "/cart" };
  var drawerWrap = document.getElementById("shopify-section-cart-drawer");

  function getDrawer() { return document.getElementById("CartDrawer"); }
  function lockScroll(on) {
    document.documentElement.classList.toggle("cart-open", on);
    if (lenis) { on ? lenis.stop() : lenis.start(); }
  }
  function openCart() {
    var d = getDrawer();
    if (!d) return;
    void d.offsetWidth; // force reflow so the slide-in animates after re-render
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    lockScroll(true);
  }
  function closeCart() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    lockScroll(false);
  }
  function updateCount(n) {
    document.querySelectorAll("#cartCount").forEach(function (el) { el.textContent = n; });
  }
  function refreshDrawer(thenOpen) {
    return fetch(R.cart_url + "?section_id=cart-drawer", { headers: { Accept: "text/html" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (!drawerWrap) return;
        drawerWrap.innerHTML = html;
        var d = getDrawer();
        if (d) updateCount(d.getAttribute("data-count") || "0");
        if (thenOpen) openCart();
      })
      .catch(function () {});
  }

  // Add to cart (works on product page + anywhere a /cart/add form exists)
  document.addEventListener("submit", function (e) {
    var f = e.target.closest('form[action$="/cart/add"], form#productForm');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('[name="add"]');
    var label = btn ? btn.innerHTML : "";
    if (btn) { btn.classList.add("is-loading"); btn.disabled = true; btn.innerHTML = "Adding…"; }
    fetch(R.cart_add, {
      method: "POST",
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: new FormData(f),
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () { return refreshDrawer(true); })
      .catch(function () { f.submit(); })
      .finally(function () {
        if (btn) { btn.classList.remove("is-loading"); btn.disabled = false; btn.innerHTML = label; }
      });
  });

  // Quick-add straight from a product card (keeps fast buyers on the page)
  document.addEventListener("click", function (e) {
    var qa = e.target.closest("[data-quick-add]");
    if (!qa) return;
    e.preventDefault();
    var id = qa.getAttribute("data-variant-id");
    if (!id || qa.classList.contains("is-loading")) return;
    var label = qa.innerHTML;
    qa.classList.add("is-loading"); qa.disabled = true; qa.innerHTML = "Adding…";
    fetch(R.cart_add, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ id: id, quantity: 1 }),
    }).then(function (r) {
      if (!r.ok) throw new Error("add failed");
      return r.json();
    }).then(function () {
      qa.innerHTML = "Added ✓";
      return refreshDrawer(true);
    }).catch(function () {
      window.location.href = qa.getAttribute("data-product-url") || R.cart_url;
    }).finally(function () {
      setTimeout(function () {
        qa.classList.remove("is-loading"); qa.disabled = false; qa.innerHTML = label;
      }, 1100);
    });
  });

  // Drawer interactions (delegated, so they survive re-renders)
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-close]")) { e.preventDefault(); closeCart(); return; }
    if (e.target.closest("[data-cart-toggle]")) { e.preventDefault(); refreshDrawer(true); return; }
    var btn = e.target.closest("[data-qty-inc],[data-qty-dec],[data-remove]");
    if (btn) {
      e.preventDefault();
      var key = btn.getAttribute("data-key");
      var qty = parseInt(btn.getAttribute("data-qty") || "0", 10);
      var isRemove = btn.hasAttribute("data-remove");
      var isInc = btn.hasAttribute("data-qty-inc");
      var newQty = isRemove ? 0 : isInc ? qty + 1 : Math.max(0, qty - 1);
      fetch(R.cart_change, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: newQty }),
      }).then(function () { return refreshDrawer(false); });
    }
  });

  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

  /* ============================================================
     First-order email popup — shows once per visitor after a delay.
     ============================================================ */
  (function () {
    var pop = document.getElementById("emailPopup");
    if (!pop) return;
    var KEY = "ff_popup_seen";
    var inEditor = window.Shopify && window.Shopify.designMode;
    function show() { pop.classList.add("is-open"); pop.setAttribute("aria-hidden", "false"); }
    function dismiss() {
      pop.classList.remove("is-open"); pop.setAttribute("aria-hidden", "true");
      try { if (!inEditor) localStorage.setItem(KEY, "1"); } catch (e) {}
    }
    pop.addEventListener("click", function (e) { if (e.target.closest("[data-popup-close]")) dismiss(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && pop.classList.contains("is-open")) dismiss(); });

    if (inEditor) { show(); return; }                       // always visible while editing
    if (pop.getAttribute("data-success") === "1") {         // just signed up → show the code
      show(); try { localStorage.setItem(KEY, "1"); } catch (e) {}
      return;
    }
    var seen = false; try { seen = localStorage.getItem(KEY) === "1"; } catch (e) {}
    if (seen) return;
    var delay = (parseInt(pop.getAttribute("data-delay"), 10) || 6) * 1000;
    setTimeout(show, delay);
  })();

  /* ============================================================
     Predictive search — opens a panel, debounced live results.
     Without JS the Search link still goes to the full search page.
     ============================================================ */
  (function () {
    var panel = document.getElementById("searchPanel");
    if (!panel) return;
    var input = document.getElementById("searchInput");
    var results = document.getElementById("searchResults");
    var R2 = window.routes || {};
    var endpoint = R2.predictive_search_url || "/search/suggest";

    function open() {
      panel.classList.add("is-open");
      panel.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("cart-open");
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      panel.classList.remove("is-open");
      panel.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("cart-open");
    }

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-search-toggle]")) { e.preventDefault(); open(); }
      else if (e.target.closest("[data-search-close]")) { close(); }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    var t, lastQ = "";
    if (input) {
      input.addEventListener("input", function () {
        var q = input.value.trim();
        clearTimeout(t);
        if (q.length < 2) { results.innerHTML = ""; lastQ = ""; return; }
        if (q === lastQ) return;
        t = setTimeout(function () {
          lastQ = q;
          var u = endpoint + "?q=" + encodeURIComponent(q) +
                  "&resources[type]=product,query&resources[limit]=8&section_id=predictive-search";
          fetch(u, { headers: { Accept: "text/html" } })
            .then(function (r) { return r.text(); })
            .then(function (html) { results.innerHTML = html; })
            .catch(function () {});
        }, 220);
      });
    }
  })();

  /* ============================================================
     Collection filters — auto-apply on change.
     Progressive: without JS the <noscript> Apply button still works.
     ============================================================ */
  (function () {
    var ff = document.getElementById("CollectionFilterForm");
    if (!ff) return;
    ff.addEventListener("change", function () {
      if (ff.requestSubmit) ff.requestSubmit(); else ff.submit();
    });
  })();

  /* ============================================================
     Product page — gallery, zoom, variant image, size guide, bar
     ============================================================ */
  (function () {
    var main = document.getElementById("pdpMain");
    if (!main) return;
    var thumbs = document.getElementById("pdpThumbs");
    var stageWrap = document.getElementById("pdpStage");
    var zoom = document.getElementById("pdpZoom");
    var zoomImg = document.getElementById("pdpZoomImg");
    var zoomBtn = document.getElementById("pdpZoomBtn");
    var form = document.getElementById("productForm");
    var vsel = document.getElementById("variantSelect");

    function setMain(src, btn) {
      if (!src) return;
      main.src = src;
      if (!thumbs) return;
      thumbs.querySelectorAll(".pdp__thumb").forEach(function (t) { t.classList.remove("is-active"); });
      var active = btn || thumbs.querySelector('.pdp__thumb[data-full="' + src + '"]');
      if (active) active.classList.add("is-active");
    }

    if (thumbs) {
      thumbs.addEventListener("click", function (e) {
        var b = e.target.closest(".pdp__thumb");
        if (b) setMain(b.getAttribute("data-full"), b);
      });
    }

    // variant selection → swap the main image (when the variant has its own photo)
    var vimgs = window.__pdpVariantImages || {};
    if (form && vsel && Object.keys(vimgs).length) {
      form.addEventListener("change", function () {
        var url = vimgs[vsel.value];
        if (url) setMain(url);
      });
    }

    // zoom overlay
    function openZoom() { if (!zoom) return; zoomImg.src = main.src; zoom.classList.add("is-open"); zoom.setAttribute("aria-hidden", "false"); document.documentElement.classList.add("cart-open"); }
    function closeZoom() { if (!zoom) return; zoom.classList.remove("is-open"); zoom.setAttribute("aria-hidden", "true"); document.documentElement.classList.remove("cart-open"); }
    if (zoom) {
      if (stageWrap) stageWrap.addEventListener("click", function (e) { if (!e.target.closest(".pdp__zoom")) openZoom(); });
      if (zoomBtn) zoomBtn.addEventListener("click", function (e) { e.stopPropagation(); openZoom(); });
      zoom.addEventListener("click", closeZoom);
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeZoom(); });
    }

    // size guide drawer
    var sg = document.getElementById("sizeGuide");
    if (sg) {
      var sgClose = function () { sg.classList.remove("is-open"); sg.setAttribute("aria-hidden", "true"); document.documentElement.classList.remove("cart-open"); };
      document.addEventListener("click", function (e) {
        if (e.target.closest("[data-sizeguide]")) { e.preventDefault(); sg.classList.add("is-open"); sg.setAttribute("aria-hidden", "false"); document.documentElement.classList.add("cart-open"); }
        else if (e.target.closest("[data-sizeguide-close]")) { sgClose(); }
      });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") sgClose(); });
    }

    // sticky mobile add-to-bag (shows when the real button scrolls off-screen)
    var add = document.getElementById("pdpAdd");
    var bar = document.getElementById("pdpBar");
    var barAdd = document.getElementById("pdpBarAdd");
    if (add && bar) {
      if (add.disabled && barAdd) { barAdd.disabled = true; barAdd.textContent = add.textContent.trim(); }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var off = !en.isIntersecting;
          bar.classList.toggle("is-visible", off);
          bar.setAttribute("aria-hidden", off ? "false" : "true");
        });
      }, { rootMargin: "0px 0px -40px 0px" });
      io.observe(add);
      if (barAdd) barAdd.addEventListener("click", function () {
        if (add.disabled) return;
        if (form && form.requestSubmit) form.requestSubmit(); else add.click();
      });
    }
  })();
})();
